import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../../../action';
import * as c from '../../../constant';

function AdministratorDetails({
  getMachineryOwnerList,
  ownerList,
  getSingleMachineryOwner,
  isLoadingGetSingleMachineryOwner,
  formData,
  setFormData,
  setSelectedIndex,
  validateForm,
}) {
  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const handleOnSelectAdminUser = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    getSingleMachineryOwner(e.value, {}, ({ data }) => {
      setFormData({
        ...formData,
        [key]: e.value,
        beneficial_user_telephone_no: data.attributes.telephone_no,
        beneficial_user_tin: data.attributes.tin,
        beneficial_user_region_code: data.attributes.region_name,
        beneficial_user_province_code: data.attributes.province_name,
        beneficial_user_municipality_code: data.attributes.municipality_name,
        beneficial_user_barangay_code: data.attributes.barangay_name,
        beneficial_user_address_line: data.attributes.address_line,
      });
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    getMachineryOwnerList();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <>
      <div className="row">
        <div className="col-12 mb-2">
          <div className="header-modal">
            Administrator/Beneficial User Details
          </div>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="beneficial_user_id" className="form-label">
            Administrator/Beneficial User
          </label>
          <Select
            options={ownerOptions}
            placeholder="-Select-"
            value={
              ownerOptions.filter(
                (item) =>
                  +_.get(formData, 'beneficial_user_id') === +_.get(item, 'id')
              ) || ''
            }
            onChange={handleOnSelectAdminUser('beneficial_user_id')}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="beneficial_user_telephone_no" className="form-label">
            Telephone No.
          </label>
          <InputMask
            className="form-control"
            mask="99-9999-9999"
            alwaysShowMask
            type="text"
            readOnly
            name="beneficial_user_telephone_no"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_telephone_no')}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="beneficial_user_tin" className="form-label mb-0">
            Tax Identification Number
          </label>
          <InputMask
            className="form-control"
            mask="999-999-999-999"
            readOnly
            type="text"
            name="beneficial_user_tin"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_tin') || ''}
          />
        </div>
        <div className="col-12 mt-2 mb-2">
          <div className="header-modal">Address</div>
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="beneficial_user_region_code"
            className="form-label mb-0"
          >
            Region
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="beneficial_user_region_code"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_region_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="beneficial_user_province_code"
            className="form-label mb-0"
          >
            Province
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="beneficial_user_province_code"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_province_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="beneficial_user_municipality_code"
            className="form-label mb-0"
          >
            Municipality
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="beneficial_user_municipality_code"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_municipality_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="beneficial_user_barangay_code"
            className="form-label mb-0"
          >
            Barangay
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="beneficial_user_barangay_code"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_barangay_code') || ''}
          />
        </div>
        <div className="col-12 form-group">
          <label
            htmlFor="beneficial_user_address_line"
            className="form-label mb-0"
          >
            Unit No. / House No. / Street Name
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="beneficial_user_address_line"
            onChange={onChange}
            value={_.get(formData, 'beneficial_user_address_line') || ''}
          />
        </div>
      </div>
      <hr className="below-hr" />
      <div className="py-1">
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={() => setSelectedIndex(0)}
            className="btn btn-light button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
            disabled={isLoadingGetSingleMachineryOwner}
          >
            Back
          </button>
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            disabled={
              !validateForm.response.is_passed ||
              isLoadingGetSingleMachineryOwner
            }
          >
            Proceed
          </button>
        </div>
      </div>
    </>
  );
}

AdministratorDetails.defaultProps = {};

AdministratorDetails.propTypes = {
  getMachineryOwnerList: PropTypes.instanceOf(Function).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  getSingleMachineryOwner: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  setSelectedIndex: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  isLoadingGetSingleMachineryOwner: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoadingGetSingleMachineryOwner:
    api.loading.indexOf(c.GET_SINGLE_MACHINERY_OWNER) > -1,
  ownerList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AdministratorDetails);
